import resso from 'resso';


const question = resso({
  descs:[]
});

export default question